/**
 * Option lists for the wizard's non-taxonomy dropdowns.
 *
 * These are plain enumerations, not taxonomy: nothing about a Region narrows
 * the Languages on offer, and a Quality setting has no compatibility
 * relationship with anything. Routing them through the taxonomy engine would
 * mean inventing registries and compatibility rules that do not exist, so they
 * follow the same shape Batch Size already uses — a list, a value, done.
 */

/** Cultural/market context. Influences imagery, idiom and content conventions. */
export const REGIONS = [
  'Global', 'North America', 'United Kingdom', 'Europe', 'Middle East',
  'India', 'Southeast Asia', 'East Asia', 'Africa', 'Latin America', 'Oceania',
];

/** Language the generated copy is written in. */
export const LANGUAGES = [
  'English', 'Spanish', 'French', 'German', 'Portuguese', 'Italian',
  'Arabic', 'Hindi', 'Gujarati', 'Chinese (Simplified)', 'Japanese',
];

/**
 * How hard the pipeline works for a result. Read as a generation preference —
 * it does not expose repair counts or thresholds to the operator.
 */
export const QUALITY_LEVELS = ['Balanced', 'Draft', 'High', 'Maximum'];

/** How far concepts may diverge from one another and from the safe answer. */
export const VARIATION_LEVELS = ['Balanced', 'Conservative', 'Adventurous'];

/** Whether the design should lean on photography, and where it comes from. */
export const IMAGE_PREFERENCES = [
  'Photography (auto source)', 'Photography — Pixabay', 'Photography — Pexels',
  'Photography — Unsplash', 'Minimal imagery', 'No photography',
];
